enum Status {
	COMPLETED = 'проведен',
	IN_PROGRESS = 'не проведен',
}

export default Status;
